import { useMemo } from 'react';
import type { ProcessLayoutForView } from '@bliks-io/ui';
import { layoutToSavedPositions, useProcessLayout } from '@/api/queries/useProcessLayout';

export function useProcessLayoutForView(processId: string, enabled: boolean): ProcessLayoutForView {
  const layout = useProcessLayout(processId, 'published', { enabled });
  const savedPositions = useMemo(() => layoutToSavedPositions(layout.data), [layout.data]);
  return {
    isPending: layout.isPending,
    savedPositions,
    swimlaneOrder: layout.data?.swimlaneOrder,
    laneColors: layout.data?.laneColors
  };
}
